import { PrimaryAccountClassesService } from '@/modules/global-settings/general-ledger/services/primary-account-classes.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';

// Create a new instance of the primary account categories service
const primaryAccountClassesService = new PrimaryAccountClassesService();

// Primary account categories module state
export const state = {
  primaryAccountClasses: [],
  primaryAccountClass: {}
};

// Primary account categories module mutations
export const mutations = {
  ...make.mutations(state),

  SET_PRIMARY_ACCOUNT_CLASSES: (state, payload) => {
    state.primaryAccountClasses = payload;
  },

  ADD_PRIMARY_ACCOUNT_CLASS: (state, payload) => {
    state.primaryAccountClasses.push(payload);
  },

  UPDATE_PRIMARY_ACCOUNT_CLASS: (state, { id, payload }) => {
    const index = state.primaryAccountClasses.findIndex((el) => el.id == id);
    state.primaryAccountClasses.splice(index, 1, payload);
  },

  UPDATE_DEFAULT_ACCOUNT_CLASSES: (state, payload) => {
    state.primaryAccountClasses.forEach(accountClass => {
        if (accountClass.useDefaultNumbers) {
          // Find the matching default class
          const defaultClass = payload.find(def => def.name === accountClass.name);
          if (defaultClass) {
            // Set the accountNumber on the class
            accountClass.accountNumber = defaultClass.accountNumber;
        }
      }
    });
  },

  REMOVE_PRIMARY_ACCOUNT_CLASS(state, id) {
    const index = state.primaryAccountClasses.findIndex((el) => el.id == id);
    state.primaryAccountClasses.splice(index, 1);
  },
};

// Primary account categories module actions
export const actions = {
  ...make.actions(state),

  /**
   * Fetch all primary account classes
   * @param {*} Object - Vuex context 
   * @returns Array - Primary account classes
   */
  fetchPrimaryAccountClasses: async ({ commit }) => {
    try {
      const { data } = await primaryAccountClassesService.findAll();
      commit('SET_PRIMARY_ACCOUNT_CLASSES', data);
      return data;
    } catch (error) {
      Logger.error('fetching primary account classes');
      throw error;
    }
  },

  /**
   * Create a new primary account class
   * @param {*} Object - Vuex context
   * @param {*} Object - Primary account class data
   */
  createPrimaryAccountClass: async ({ commit }, payload) => {
    try {
      const { data } = await primaryAccountClassesService.create(payload);
      commit('ADD_PRIMARY_ACCOUNT_CLASS', data);
      return data;
    } catch (error) {
      Logger.error('creating primary account class');
      throw error;
    }
  },

  /**
   * Update a primary account class with the given id and data
   * @param {*} Object - Vuex context
   * @param {*} Object - Primary account class ID & Primary account class data
   */
  updatePrimaryAccountClass: async ({ commit }, { id, payload }) => {
    try {
      await primaryAccountClassesService.update(id, payload);
      commit('UPDATE_PRIMARY_ACCOUNT_CLASS', { id, payload });
    } catch (error) {
      Logger.error('updating primary account class');
      throw error;
    }
  },

  /**
   * Delete a primary account class with the given id
   * @param {*} Object - Vuex context
   * @param {*} Object - Primary account class ID 
   */
  deletePrimaryAccountClass: async ({ commit }, id) => {
    try {
      // Call the service to delete the record
      await primaryAccountClassesService.delete(id);
  
      // Commit the mutation to remove the record from the state
      commit('REMOVE_PRIMARY_ACCOUNT_CLASS', id);
  
      return true; // Return success response
    } catch (error) {
      Logger.error('Error deleting primary account class', error);
      throw error;
    }
  },
};

// Primary account categories module getters
export const getters = make.getters(state);
